/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import MonthPicker from "@9softstudio/react-monthpicker";
import * as API from "../../http/api";
import { useHistory } from "react-router-dom";
import { defaultProps, formatdate } from "../../util/DateUtil";
import { ReassingnLogistic } from "../modals";
import { openlightbox } from "../../util/Functions";
import { Cancel, Edit, ExpandMore, Save } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, IconButton, TextField, Tooltip, Typography } from "@mui/material";
import DataTable from "react-data-table-component";
import Checkbox from "@mui/material/Checkbox";
import { ThemeProvider } from "@mui/material/styles";
import { theme, customStyles } from "../../util/TableStyles"
import { noDataComponent } from "../../util/DataObject"
import moment from "moment";
import "moment/locale/es";

const LogisticReport = (props) => {
  moment.locale("es");
  const history = useHistory();
  const [mSelect, setM] = useState("");
  const [ySelect, setY] = useState("");
  const [disabled, setDisabled] = useState(true);
  const [agent, setAgent] = useState("");
  const [data, setData] = useState([]);
  const [analysts, setAnalysts] = useState([]);
  const [maxReg, setMaxReg] = useState(50);
  const [maxMonth, setMaxMonth] = useState(1);
  const [maxYear, setMaxYear] = useState(2016);
  const [tabActive, setTabActive] = useState("");
  const [agents, setAgents] = useState([]);
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [pagesAgents, setPagesAgents] = useState(0);
  const [maxRegAgents, setMaxRegAgents] = useState(50);
  const [tabs, setTabs] = useState([
    { name: "AGENTS", title: "Agentes" },
    { name: "CARDS", title: "Tarjetas por personalizar" },
  ]);
  const [clear, setClear] = useState(false);
  const [asignados, setAsignados] = useState(0);
  const [enviados, setEnviados] = useState(0);
  const [personalizar, setPersonalizar] = useState(0);
  const [errors, setErrors] = useState(0);
  const [recibidas, setRecibidas] = useState(0);
	const [expanded, setExpanded] = useState(false);
  const [maxAssign, setMaxAssign] = useState(0);
  const [maxError, setMaxErrors] = useState(false);
  const [state, setState] = useState({});

  const quantity = [
    { name: "", title: "Asignados: ", data: asignados },
    { name: "CARDS", title: "Error: ", data: errors },
    { name: "CARDS", title: "Personalizado: ", data: personalizar },
    { name: "CARDS", title: "Enviadas: ", data: enviados },
    { name: "CARDS", title: "Recibidas: ", data: recibidas },
    { name: "AGENTS", title: "Envios: ", data: enviados },
  ];

  useEffect(() => {
    init();
  }, [props.content]);

  const init = () => {
    setDisabled(true);
    if (props.content.type == "agents") {
      setTabActive("AGENTS");
    }
    if (props.content.type == "cards") {
      setTabActive("CARDS");
    }
    let today = new Date();
    let m = today.getMonth() + 1;
    let y = today.getFullYear();
    let a = 0;
    let r = 0;
    if (props.content.type == "agents") {
      for (let i = 0; i < props.content.data.length; i++) {
        a += props.content.data[i]["assigned"];
        r += props.content.data[i]["finished"];
      }
      if (props.content.hasOwnProperty("data")) {
        let d = [];
        for (let i = 0; i < maxRegAgents; i++) {
          if (props.content.data[i]) {
            d.push(props.content.data[i]);
          }
        }
        let pagesAux = Math.floor(props.content.data.length / maxRegAgents);
        if (pagesAgents < props.content.data.length / maxRegAgents) {
          pagesAux += 1;
        }
        setPagesAgents(pagesAux);
        setData(JSON.parse(JSON.stringify(d)));
        if (props.content.hasOwnProperty("oldAgents")) {
          setAgents(JSON.parse(JSON.stringify(props.content.oldAgents)));
        } else {
          setAgents(JSON.parse(JSON.stringify(props.content.data)));
        }
      }
    }

    if (props.content.type == "cards") {
      if (props.content.hasOwnProperty("cards")) {
        setData(JSON.parse(JSON.stringify(props.content.cards)));
      }
      if (props.content.hasOwnProperty("agents")) {
        setAgents(JSON.parse(JSON.stringify(props.content.agents)));
      }
      if (props.content.hasOwnProperty("agent")) {
        setAgent(props.content.agent);
      }
      if (props.content.hasOwnProperty("totalReceived")) {
        setRecibidas(props.content.totalReceived);
      }
      if (props.content.hasOwnProperty("totalAssigned")) {
        a = props.content.totalAssigned;
      }
      if (props.content.hasOwnProperty("totalCustomizing")) {
        setPersonalizar(props.content.totalCustomizing);
      }
      if (props.content.hasOwnProperty("totalError")) {
        setErrors(props.content.totalError);
      }
      if (props.content.hasOwnProperty("totalSent")) {
        r = props.content.totalSent;
      }
    }
    if (props.content.hasOwnProperty("limit")) {
      setMaxReg(props.content.limit);
    }

    setAsignados(a);
    setEnviados(r);
    setMaxMonth(m);
    setMaxYear(y);
  };

  const changeTab = (tab) => {
    if (tabActive == tab) {
      return;
    }

    if (tab == "AGENTS") {
      setAgent("");
      let today = new Date();
      let month = today.getMonth() + 1;
      let year = today.getFullYear();
      changeMonth(month, year, tab, "");
    }

    if (tab == "CARDS") {
      props.changeLoader(true);
      setAgent("");
      let today = new Date();
      let month = today.getMonth() + 1;
      let year = today.getFullYear();
      changeMonth(month, year, tab, "");
    }
  };

  const changeMonth = async (
    month,
    year,
    tab,
    agentUuid = "",
    todos = false
  ) => {
    setM(month);
    setY(year);
    if (!tab) {
      tab = tabActive;
    }
    props.changeLoader(true);
    let startDate = start;
    let endDate = end;

    if (month && year) {
      startDate = new Date(moment(`${year}-${month.toString().padStart(2, "0")}-01`).tz("America/Mexico_City").format()).toJSON();
      let final = new Date(moment(`${year}-${month + 1}-01`).tz("America/Mexico_City").format()).getTime() - 1;
      endDate = new Date(final).toJSON();      
    }

    let data = {
      startDate: startDate,
      endDate: endDate,
    };
    setStart(startDate);
    setEnd(endDate);

    if (agentUuid) {
      data["agent_uuid"] = agentUuid;
    }
    if (tab == "CARDS") {
      if (!agentUuid && !todos) {
        agentUuid = agent;
      }
      await findCards(agentUuid, 1, startDate, endDate, "assigned");
    }
    if (tab == "AGENTS") {
      if (!agentUuid) {
        setAgent("");
      }
      data["type"] = "agents";
      let request = await API.service("logisticReport", data, props.pos, props.changeAlert, props.changeLoader, history);
      if (request.status === 200 && request.data.data.response === "OK") {
        if (agentUuid) {
          request.data.data.widget[0].content["oldAgents"] = agents;
        }
        props.changeWidgets(request.data.data.widget);
      }
    }
    props.changeLoader(false);
  };

  const findCards = async (
    customer,
    pageCurrent,
    startDate = "",
    endDate = "",
    status = ""
  ) => {
    props.changeLoader(true);
    let req = {
      type: "cards",
      page: pageCurrent,
      limit: maxReg,
      agent_uuid: customer ? customer : "",
    };

    if (startDate) {
      req["startDate"] = startDate;
    }
    if (endDate) {
      req["endDate"] = endDate;
    }
    if (status) {
      req["status"] = status;
    }
    let request = await API.service("logisticReport", req, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.status === 200 && request.data.data.response === "OK") {
      props.changeWidgets(request.data.data.widget);
    }
    props.changeLoader(false);
  };

  const changeAgent = async (e) => {
    setAgent(e.target.value);
    if (tabActive == "CARDS") {
      let today = new Date();
      let month = today.getMonth() + 1;
      let year = today.getFullYear();
      if (mSelect) {
        month = Number(mSelect);
      }
      if (ySelect) {
        year = Number(ySelect);
      }
      let todos = false;
      if (!e.target.value) {
        todos = true;
      }
      changeMonth(month, year, "CARDS", e.target.value, todos);
    }
    if (tabActive == "AGENTS") {
      changeMonth(false, false, "AGENTS", e.target.value);
    }
  };

  const openModal = (dataSelected) => {
    let contentModal = {
      title: "Reasignar Tarjetas",
      agents: agents,
      cards: dataSelected,
    };
    const as = (
      <ReassingnLogistic
        pos={props.pos}
        changeAlert={props.changeAlert}
        changeLoader={props.changeLoader}
        contentModal={contentModal}
        reassign={reassign}
        key="cardCancelW"
      />
    );
    openlightbox(as);
  };

  const reassign = async (cards, agent_uuid, close) => {
    let t = close;
    props.changeLoader(true);
    let req = {
      agent_uuid: agent_uuid,
      cards: cards,
    };
    let request = await API.service("reassignLogistic", req, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.status === 200 && request.data.data.response === "OK") {
      t();
      let today = new Date();
      let month = today.getMonth() + 1;
      let year = today.getFullYear();
      let startDate = new Date(moment(`${year}-${month.toString().padStart(2, "0")}-01`).tz("America/Mexico_City").format()).toJSON();
      let final = new Date(moment(`${year}-${month + 1}-01`).tz("America/Mexico_City").format()).getTime() - 1;
      let endDate = new Date(final).toJSON();
      await findCards("", 1, startDate, endDate, "assigned");
    }
    props.changeLoader(false);
  };

  const selected = (data) => {
    if (data.selectedCount > 0) {
      const s = [];
      for (let i = 0; i < data.selectedRows.length; i++) {
        s.push(data.selectedRows[i]);
      }
      setState(s);
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  };

  const closeForm = (item) => {
		let conf = analysts;
		for(let i = 0; i<conf.length; i++){
			if(conf[i]['uuid'] == item['uuid']){
				conf[i]['edit'] = false;
			}
		}

		setAnalysts(JSON.parse(JSON.stringify(conf)));
	}

  // Max Assigned ---------------------------------------------
  const getAgents = async () => {
    props.changeLoader(true);

    let data = {
			roles: 'inext-role-logistics-operations'
		}

    let request = await API.service("findAgentsLogistic", data, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.status === 200 && request.data.data.response === "OK") {
      let agentsLogistic = request.data.data.content
			setAnalysts(JSON.parse(JSON.stringify(agentsLogistic)));
    }
    props.changeLoader(false);
  }

  const editAsign = async (uuid) => {
		props.changeLoader(true);
		let data = {
			maxAssign: maxAssign,
			uuid: uuid,
			prop: 'maxAssignedLogistic'
		}
		let request = await API.service('updateMaxAssign', data, props.pos, props.changeAlert, props.changeLoader, history);
		if (request.status == 200 &&  request.data.data.response == "OK" ) {
			await getAgents();
      props.changeAlert(true, 'success', 'Cantidad de asignaciones actualizada con éxito.');
		}
		props.changeLoader(false);
  }

  const formMaxAssigned = (item) => {
		let conf = analysts;
		let max = maxAssign;
		for(let i = 0; i<conf.length; i++){
			if(conf[i]['uuid'] == item['uuid']){
				conf[i]['edit'] = true;
				max = item['maxAssigned'];
			}else{
				conf[i]['edit'] = false;
			}
		}
		setMaxAssign(max);
		setAnalysts(JSON.parse(JSON.stringify(conf)));
	}
  
  const changeMaxAssign = (e) => {
    if(e.target.value < 0 || e.target.value > 100){
      setMaxErrors(true)
    } else {
      setMaxErrors(false)
    }
		setMaxAssign(e.target.value);
	}

  const changeExpanded = async (e, flag) => {
		if(flag){
			await getAgents();
		}else{
			setAnalysts([]);
		}
		setExpanded(flag);
	}

  const columnsAgents = [
    { selector: (row) => row.name, name: "Nombre de agente", width:"26%", wrap: true, sortable: true },
    { selector: (row) => row.email, name: "Email", width:"26%", wrap: true, sortable: true },
    { selector: (row) => row.assigned, name: "No. Asignaciones", width:"18%", sortable: true },
    { selector: (row) => row.error, name: "No. Errores", width:"15%", sortable: true },
    { selector: (row) => row.finished, name: "No. Envios", width:"15%", sortable: true },
  ];

  const columnsCards = [
    { selector: (row) => row.customer?.name ? row.customer.name : "Migrar dato", name: "Nombre de cliente", width:"20%", wrap: true, sortable: true },
    { selector: (row) => row.customer?.email ? row.customer.email : "Migrar dato", name: "Email", width:"28%", wrap: true, sortable: true },
    { selector: (row) => row.agent?.name ? row.agent.name : "Migrar dato", name: "Agente", width:"20%", sortable: true },
    { selector: (row) => row.adate ? moment(row.adate).format('LLL') : '', name: "Fecha estatus", sortable: true },
  ];

  const columnsAnalysts = [
    { selector: (row) => row.name, name: "Nombre", width:"28%", wrap: true, sortable: true },
    { selector: (row) => row.email, name: "Email", width:"28%", wrap: true, sortable: true },
    { cell: (item) => {
        return <>
          {!item.edit && <span>{item.maxAssigned}</span>}
          { item.edit && <>
            <TextField inputProps={{ style: {color: maxError ?'red' : ''}}} variant="standard" type="number" value={maxAssign} onChange={changeMaxAssign.bind(this)}/>
            </> } </>
      },      
      name: `Máximo No. de asignaciones`, width:"30%", center: true, sortable: true },
    { cell: (item) => {
      return (
        <div style={{display: "flex"}}>
          { !item.edit &&
            <Tooltip title="Cambiar número máximo de asignaciones">
              <IconButton onClick={formMaxAssigned.bind(this, item)}><Edit/></IconButton>
            </Tooltip>            
          }
          { item.edit &&
            <>
              <Tooltip title="Guardar">
                <IconButton disabled={maxAssign.toString().length == 0 || maxAssign < 0 || maxAssign > 100 ? true : false} onClick={editAsign.bind(this, item.uuid)}><Save/></IconButton>
              </Tooltip>
              <Tooltip title="Cancelar">
                <IconButton onClick={closeForm.bind(this, item)}><Cancel/></IconButton>
              </Tooltip>
            </>
          }
        </div>
      )},
      name: "Acciones", width:"13%", center: true, sortable: true},
  ];

  const paginationComponentOptions = {
    rangeSeparatorText: "de",
    noRowsPerPage: true,
  };

  return (
    <div className="size-12">
      <div className="card">
        <div className="form-row hdr_transaction">
          <div className="col-ico"><i className="ibon-card inb4" /></div>
          <h3 className="col-8 fix-elm-title-widget">Operación de Logistica</h3>
        </div>
        {
				  props.config.actions.indexOf('edit') > -1 &&
          <Accordion sx={{width: '100% !important', marginBottom: "25px"}} expanded={expanded} onChange={changeExpanded}>
            <AccordionSummary aria-controls="list-agents" id="list-agents-compliance-analyst" expandIcon={<ExpandMore/>}>
              <Typography fontWeight="400" fontFamily="Muli,sans-serif" color="#000000de" fontSize="0.875rem">
                Especialistas de Logística
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <div style={{ width: "100%", margin: "auto", maxHeight: '400px !important' }}>
                <ThemeProvider theme={theme}>
                  <DataTable style={{maxHeight: '300px !important'}}
                    columns={columnsAnalysts}
                    data={analysts}
                    customStyles={customStyles}
                    noDataComponent={noDataComponent}
                  />
                </ThemeProvider>
              </div>
            </AccordionDetails>
          </Accordion>
        }
        <div className="size-12 tabBox">
          <ul>
            {tabs.map((item, index) => {
              return (
                <li key={`admin-tabs-${index}`}
                  className={tabActive === item.name ? "active" : ""}
                  onClick={changeTab.bind(this, item.name)}
                >{item.title}</li>
              );
            })}
          </ul>
        </div>

        <div className="size-12">
          <div className="tableTools pnl-log-oper justify-end">
            {quantity.map((i) => {
              if(tabActive === i.name || i.name === ""){
                return (
                  <div key={i.title} className="tableToolsCargo tableToolsLOC desktop">
                    <i className="ibon-reports indigo"></i>
                    <div className="neutral">{i.title}</div>
                    <div className="label_saldo_apertura">{i.data}</div>
                  </div>
                )
              }
            })}
            {tabActive === "CARDS" && 
              <div className={disabled ? "disable bigButton padding-left desktop" : "bigButton padding-left desktop"} >
                <button disabled={disabled} onClick={() => openModal(state)}>
                  Reasignar
                </button>
              </div>            
            }
          </div>

          <div className="selectAgentLOC tableTools pnl-log-oper justify-end">
            <div className="inputIconRight inputGroup desktop">
              <MonthPicker
                onSelect={changeMonth.bind(this)}
                monthNames={defaultProps.monthNames}
                hasRange={true}
                onFormat={formatdate}
                isReadonly={true}
                minMonth={10}
                minYear={2016}
                maxMonth={maxMonth}
                maxYear={maxYear}
                iconElement={
                  <i className="ibon-calendar icon-calendar-pos"></i>
                }
              />
            </div>
            <div className="inputIconRight inputGroup desktop" style={{minWidth: "182px"}}>
              <select value={agent} onChange={changeAgent.bind(this)}>
                <option value="">Agente</option>
                {agents.map((data, iData) => {
                  return (
                    <option value={data.uuid} label={data.name} key={iData}>{data.name}</option>
                  );
                })}
              </select>
            </div>
          </div>
        </div>
       
        <div style={{ width: "100%", margin: "auto" }}>
          <ThemeProvider theme={theme}>
            <DataTable
              columns={tabActive === "AGENTS" ? columnsAgents : columnsCards}
              data={data}
              customStyles={customStyles}
              selectableRows={tabActive === "CARDS" ? true : false}
              selectableRowsComponent={Checkbox}
              onSelectedRowsChange={selected}
              clearSelectedRows={tabActive === "CARDS" ? false : true}
              pagination={tabActive === "CARDS" ? true : false}
              paginationPerPage={50}
              paginationComponentOptions={paginationComponentOptions}
              paginationTotalRows={props.widgets[0].content.total}
              noDataComponent={noDataComponent}
              // selectableRowSelected={(row) => {return false}}
            />
          </ThemeProvider>
        </div>
      </div>
    </div>
  );
};

export default LogisticReport;
